// extracted by mini-css-extract-plugin
module.exports = {"paymentDetailsCard":"PaymentDetailsCard_paymentDetailsCard__KdQ_A"};